module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-[37]524.aea3ff7.woff2";